import { render, staticRenderFns } from "./ReportIncomingOrders.vue?vue&type=template&id=b070a5b4"
import script from "./ReportIncomingOrders.vue?vue&type=script&lang=ts"
export * from "./ReportIncomingOrders.vue?vue&type=script&lang=ts"
import style0 from "./ReportIncomingOrders.vue?vue&type=style&index=0&id=b070a5b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports